import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import React from 'react';

function Faq() {
  const {t} = useInferableTranslation();

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '30px', padding: '20px'}}>
      <Header left={<HeaderBackButton />}>
        <div>{t('T40131')}</div>
      </Header>
    </div>
  );
}

export default Faq;
